/* ------------------------------------------------------------------
   LOOPSTATION /pages/free-sample  案A（写真そのものを選択ボタンにする）
   2026-09-17  対象施策: 260917_無料サンプルページのリニューアル.md

   方針:
     Globo(Powerful Form Builder / フォームID 20346)は残す。
     Globo側の設定は一切変更しない（設定を変えると本番へ即反映されるため、
     プレビューで見比べられなくなる）。よって是正はすべてテーマ側のこのJSで行う。

   このJSがやること（7項目の是正 + 案A）:
     1. 商品名が写真に隠れる（margin-top:-50px）→ 旧リストごと非表示にし、写真カードへ置換
     2. 写真をタップしても選べない            → カード全面がボタン。実体は元のcheckboxを操作
     3. エラーが英語 Please fill in field     → 日本語化（設定オブジェクト + 表示テキストの両方）
     4. 電話/メールが type=text               → tel / email + inputmode + autocomplete
     5. アクリルスタンドの重複（29→28）        → 重複側(checkbox-9)はカードに出さない
     6. ファーストビューに「無料で届く」がない  → 冒頭にヒーロー、配送注意書きは送信直前へ移設
     7. 送信ボタン38px                        → CSSで56px
     + サンクスページ /pages/free-sample-thanks へ遷移（計測用）

   ★ 安全方針: 対応表に無い選択肢が見つかっても「黙って落とさない」。
      最後の『その他』に画像なしで必ず出し、console に警告を出す。
   ------------------------------------------------------------------ */
(function () {
  'use strict';

  var FORM_ID = '20346';

  /* ===== 切り替えスイッチ ===== */
  // 連絡先の必須を5項目に絞る（2026-09-17 社長決定）。
  //   お名前／郵便番号／ご住所／電話番号／メール
  // 電話番号は「配送業者が使うので必須」との判断で残す。
  // 廃止するのは同意チェック2つ（宅急便の同意・内容確認の同意）＝必須7→5。
  var REQUIRED_5 = true;

  // 送信後に /pages/free-sample-thanks へ遷移する（GA4で送信を数えるため）
  var THANKS_REDIRECT = true;
  var THANKS_URL = '/pages/free-sample-thanks';

  // 先頭に出す「人気」の点数
  var POPULAR_COUNT = 8;

  var CDN = 'https://cdn.shopify.com/s/files/1/0812/4042/4723/files/';

  /* ===== 商品の対応表 =====
     value  : Globoのcheckboxのvalue（これが送信される文字列。変えてはいけない）
     img    : 元のフォームに入っていた写真（html-1〜html-8から抽出）
     name   : カードに出す名前
     sub    : 補足（カッコ内の説明）
     users  : GA4 90日(2026-06-19〜09-17)の商品ページ閲覧人数。並び順の根拠
     dup    : true = 同じ品目が2回出てくる重複側。カードには出さない            */
  var ITEMS = [
    { value: '透明シガレットケース', img: 'cigarette-case_250422_kuma.jpg', name: '透明シガレットケース', users: 109 },
    { value: 'キューブパズル', img: 'cube-sample-2.jpg', name: 'キューブパズル', users: 367 },
    { value: 'クージー【国内】', img: 'new-cousy_0024.jpg', name: 'クージー（国内）', users: 116 },
    { value: '灰皿', img: 'ashtray-sample-3.jpg', name: '灰皿', users: 78 },
    { value: 'シガレットケース', img: 'cigarette-case_250422_kuma-2.jpg', name: 'シガレットケース', users: 1812 },
    { value: 'タバコケース(加熱式たばこ収納対応)', img: 'tabakoke-su_01.jpg', name: 'タバコケース', sub: '加熱式たばこ収納対応', users: 150 },
    { value: '交換用ドアカバー(加熱式たばこ用)', img: 'iluma_door-cover_101-02.jpg', name: '交換用ドアカバー', sub: '加熱式たばこ用', users: 409 },
    { value: 'アクリルキーホルダー', img: 'list_09_05.jpg', name: 'アクリルキーホルダー', users: 2348 },
    { value: 'ラバーバンド', img: 'list_09_03.jpg', name: 'ラバーバンド', users: 352 },
    { value: 'ラバーキーホルダー', img: 'list_09_04.jpg', name: 'ラバーキーホルダー', users: 165 },
    { value: 'PVC反射パッチンバンド', img: 'list_09_12.jpg', name: 'PVC反射パッチンバンド', users: 103 },
    { value: '加熱式たばこ用ケース(2パーツ分解式)', img: 'irumake-su_01.jpg', name: '加熱式たばこ用ケース', sub: '2パーツ分解式', users: 99 },
    { value: 'ホテルキーホルダー', img: 'hotel-keychain-sample.jpg', name: 'ホテルキーホルダー', users: 93 },
    { value: 'アクリルスタンド', img: 'acrylic-stand-07-2.jpg', name: 'アクリルスタンド', users: 72 },
    { value: '使い捨てライター', img: 'lighter-sample.jpg', name: '使い捨てライター', users: 65 },
    { value: 'PVCクリアリストバンド', img: 'list_09_13.jpg', name: 'PVCクリアリストバンド', users: 51 },
    { value: 'モーテルキーホルダー', img: 'motel-keychain-sample.jpg', name: 'モーテルキーホルダー', users: 40 },
    { value: 'クージー【海外】', img: 'list_09_09.jpg', name: 'クージー（海外）', users: 24 },
    { value: 'バウンスバンド®', img: 'list_09_01.jpg', name: 'バウンスバンド®', users: 22 },
    { value: 'コルクコースター', img: 'cork-coaster-sample.jpg', name: 'コルクコースター', users: 19 },
    { value: '絵馬', img: 'ema-sample.jpg', name: '絵馬', users: 17 },
    { value: 'カード型ボトルオープナー', img: 'card-bottle-opener-sample.jpg', name: 'カード型ボトルオープナー', users: 12 },
    { value: 'パズル', img: 'puzzle-sample.jpg', name: 'パズル', users: 11 },
    { value: 'ボトルオープナー', img: 'bottle-opener-sample.jpg', name: 'ボトルオープナー', users: 6 },
    { value: 'マネークリップ', img: 'money-clip-sample.jpg', name: 'マネークリップ', users: 6 },
    { value: '枡', img: 'masu-sample-3.jpg', name: '枡', users: 0 },
    { value: 'マッチ', img: 'match-sample.jpg', name: 'マッチ', users: 0 },
    { value: 'タッチレスキー', img: 'touchless-key-sample.jpg', name: 'タッチレスキー', users: 0 }
  ];

  // 重複しているグループ（checkbox-9 の「アクリルスタンド」）は
  // checkbox-2 側を正としてカードに出す。こちらは触らない。
  var DUP_GROUP = 'checkbox-9';

  var ERRORS = {
    'Please fill in field': 'ご入力ください',
    'Invalid email': 'メールアドレスの形式をご確認ください',
    'Invalid URL': 'URLの形式をご確認ください',
    'Invalid': '入力内容をご確認ください',
    'File size limit exceeded': 'ファイルの容量が大きすぎます',
    'File extension not allowed': 'この形式のファイルは添付できません',
    'Please, enter the captcha': '画像認証をご入力ください',
    'This field is required': 'ご入力ください',
    'Next': '送信する',
    'Previous': '戻る'
  };

  function log(msg) { try { console.warn('[free-sample-ux] ' + msg); } catch (e) {} }
  function el(tag, cls) { var n = document.createElement(tag); if (cls) n.className = cls; return n; }
  function imgUrl(file) { return CDN + file + '?width=480'; }

  /* ---------- 1) Globoの設定オブジェクトのエラー文言を日本語へ ---------- */
  function patchConfigMessages() {
    try {
      var forms = window.Globo && window.Globo.FormBuilder && window.Globo.FormBuilder.forms;
      if (!forms) return false;
      var wrap = forms[FORM_ID];
      if (!wrap) return false;
      var cfg = wrap[FORM_ID] || wrap;
      if (!cfg || !cfg.errorMessage) return false;
      var m = cfg.errorMessage;
      m.required = ERRORS['Please fill in field'];
      m.invalid = ERRORS['Invalid'];
      m.invalidEmail = ERRORS['Invalid email'];
      m.invalidURL = ERRORS['Invalid URL'];
      m.fileSizeLimit = ERRORS['File size limit exceeded'];
      m.fileNotAllowed = ERRORS['File extension not allowed'];
      m.requiredCaptcha = ERRORS['Please, enter the captcha'];
      if (cfg.footer) {
        cfg.footer.nextText = '送信する';
        cfg.footer.previousText = '戻る';
      }
      return true;
    } catch (e) { return false; }
  }
  (function pollConfig() {
    var tries = 0;
    var t = setInterval(function () {
      tries++;
      if (patchConfigMessages() || tries > 200) clearInterval(t);
    }, 50);
  })();

  /* ---------- 表示されたエラー文字も日本語へ（保険） ---------- */
  function translateNode(node) {
    if (!node) return;
    var txt = (node.textContent || '').trim();
    if (!txt) return;
    if (ERRORS[txt]) { node.textContent = ERRORS[txt]; return; }
    Object.keys(ERRORS).forEach(function (k) {
      if (txt.indexOf(k) !== -1) node.textContent = txt.split(k).join(ERRORS[k]);
    });
  }
  function translateAll(root) {
    (root || document).querySelectorAll(
      '.globo-form-id-' + FORM_ID + ' small.messages, .globo-form-id-' + FORM_ID + ' .globo-error'
    ).forEach(translateNode);
  }

  /* ---------- 2) 入力欄の是正 ----------
     ★ id が数字で始まる（20346-phone-1）ため querySelector('#20346-...') は
        CSSの構文エラーになって例外を投げる。必ず getElementById を使う。 */
  function byId(id) { return document.getElementById(FORM_ID + '-' + id); }

  function fixInputs(root) {
    var f = byId;
    var phone = f('phone-1');
    if (phone && phone.type !== 'tel') {
      phone.type = 'tel';
      phone.setAttribute('inputmode', 'tel');
      phone.setAttribute('autocomplete', 'tel');
      phone.placeholder = '例）09012345678';
    }
    var mail = f('email');
    if (mail && mail.type !== 'email') {
      mail.type = 'email';
      mail.setAttribute('inputmode', 'email');
      mail.setAttribute('autocomplete', 'email');
      mail.setAttribute('autocapitalize', 'off');
      mail.setAttribute('spellcheck', 'false');
      mail.placeholder = '例）info@example.com';
    }
    var zip = f('text-2');
    if (zip && !zip.getAttribute('inputmode')) {
      zip.setAttribute('inputmode', 'numeric');
      zip.setAttribute('autocomplete', 'postal-code');
      zip.placeholder = '例）373-0000';
    }
    var name = f('text');
    if (name && !name.getAttribute('autocomplete')) {
      name.setAttribute('autocomplete', 'name');
      name.placeholder = '例）山田 太郎';
    }
    var addr = f('text-3');
    if (addr && !addr.getAttribute('autocomplete')) {
      addr.setAttribute('autocomplete', 'street-address');
      addr.placeholder = '例）群馬県太田市○○町1-2-3 ○○マンション101';
    }
    var corp = f('text-1');
    if (corp && corp.placeholder === 'corporate name') corp.placeholder = '例）株式会社ループステーション';
    var ta = f('textarea');
    if (ta && ta.placeholder === 'Message') ta.placeholder = 'ご要望・ご質問があればご記入ください（任意）';
  }

  /* ---------- 3) 写真カードを組み立てる ---------- */
  function buildPicker(root) {
    if (root.querySelector('.fs-picker')) return;

    // 元のcheckbox(value → input)の索引を作る。★空キーは索引に入れない
    var inputs = root.querySelectorAll('input.checkbox-input[type="checkbox"]');
    var byValue = {};
    var seenValues = [];
    inputs.forEach(function (inp) {
      var grp = (inp.name || '').replace('[]', '');
      if (grp === 'checkbox-1' || grp === 'checkbox-10') return; // 同意チェックは対象外
      var v = (inp.value || '').trim();
      if (!v) return;
      if (grp === DUP_GROUP) return;              // 重複側は使わない（アクリルスタンド）
      if (byValue[v]) return;                     // 先勝ち（同値が複数なら最初の1つ）
      byValue[v] = inp;
      seenValues.push(v);
    });

    // 対応表に無い選択肢を拾う（黙って落とさない）
    var known = {};
    ITEMS.forEach(function (it) { known[it.value] = true; });
    var extras = seenValues.filter(function (v) { return !known[v]; });
    if (extras.length) log('対応表にない選択肢: ' + extras.join(' / ') + ' → 画像なしで末尾に出します');

    var list = ITEMS.filter(function (it) { return !!byValue[it.value]; })
      .map(function (it) { return it; })
      .concat(extras.map(function (v) { return { value: v, name: v, users: -1 }; }));

    var missing = ITEMS.filter(function (it) { return !byValue[it.value]; });
    if (missing.length) log('フォームに無い品目（対応表のみ）: ' + missing.map(function (x) { return x.value; }).join(' / '));

    var wrap = el('div', 'fs-picker');

    var head = el('div', 'fs-picker__head');
    var h = el('h3', 'fs-picker__title'); h.textContent = 'ほしいサンプルを選んでください';
    var cnt = el('span', 'fs-picker__count'); cnt.textContent = '選択中 0点';
    head.appendChild(h); head.appendChild(cnt);
    wrap.appendChild(head);

    var sub = el('p', 'fs-picker__sub');
    sub.textContent = '写真をタップすると選べます。各アイテム1点ずつのお届けです（カラー・デザインの指定はできません）。';
    wrap.appendChild(sub);

    var gridTop = el('ul', 'fs-grid');
    var gridRest = el('ul', 'fs-grid');

    function card(it) {
      var li = el('li');
      var b = el('button', 'fs-card');
      b.type = 'button';
      b.setAttribute('aria-pressed', 'false');
      b.setAttribute('data-value', it.value);

      var iw = el('div', 'fs-card__imgwrap');
      if (it.img) {
        var im = el('img', 'fs-card__img');
        im.src = imgUrl(it.img);
        im.alt = '';
        im.loading = 'lazy';
        im.decoding = 'async';
        iw.appendChild(im);
      } else {
        var ni = el('div', 'fs-card__noimg');
        ni.textContent = '写真なし';
        iw.appendChild(ni);
      }
      var mk = el('span', 'fs-card__mark');
      iw.appendChild(mk);
      b.appendChild(iw);

      var nm = el('span', 'fs-card__name');
      nm.textContent = it.name || it.value;
      b.appendChild(nm);
      if (it.sub) { var sb = el('span', 'fs-card__sub'); sb.textContent = it.sub; b.appendChild(sb); }

      b.addEventListener('click', function () {
        var inp = byValue[it.value];
        if (!inp) return;
        inp.checked = !inp.checked;
        inp.dispatchEvent(new Event('change', { bubbles: true }));
        inp.dispatchEvent(new Event('input', { bubbles: true }));
        sync();
      });
      li.appendChild(b);
      return li;
    }

    list.forEach(function (it, i) {
      (i < POPULAR_COUNT ? gridTop : gridRest).appendChild(card(it));
    });

    wrap.appendChild(gridTop);

    var restCount = list.length - Math.min(POPULAR_COUNT, list.length);
    if (restCount > 0) {
      var more = el('div', 'fs-more');
      var mb = el('button', 'fs-more__btn');
      mb.type = 'button';
      mb.setAttribute('aria-expanded', 'false');
      mb.innerHTML = 'ほかの商品も見る（' + restCount + '点）<span class="fs-more__caret">▼</span>';
      var box = el('div');
      box.hidden = true;
      box.style.marginTop = '10px';
      box.appendChild(gridRest);
      mb.addEventListener('click', function () {
        var open = box.hidden;
        box.hidden = !open;
        mb.setAttribute('aria-expanded', open ? 'true' : 'false');
        mb.innerHTML = (open ? '閉じる' : 'ほかの商品も見る（' + restCount + '点）') +
          '<span class="fs-more__caret">' + (open ? '▲' : '▼') + '</span>';
      });
      more.appendChild(mb);
      more.appendChild(box);
      wrap.appendChild(more);
    }

    function sync() {
      var n = 0;
      wrap.querySelectorAll('.fs-card').forEach(function (b) {
        var inp = byValue[b.getAttribute('data-value')];
        var on = !!(inp && inp.checked);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        if (on) n++;
      });
      // ★ 同じ文字なら書き換えない。書き換えるとMutationObserverが再帰的に走る
      var t1 = '選択中 ' + n + '点';
      if (cnt.textContent !== t1) cnt.textContent = t1;
      var note = document.querySelector('.fs-submit-count');
      var t2 = n === 0 ? 'サンプルが選ばれていません' : 'サンプル ' + n + '点を請求します';
      if (note && note.textContent !== t2) note.textContent = t2;
    }
    wrap.__fsSync = sync;

    var anchor = root.querySelector('[data-element-id="checkbox-3"]');
    if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(wrap, anchor);
    else return;

    sync();
  }

  /* ---------- 4) ファーストビュー・配送注意書きの移設・セクション見出し ---------- */
  function buildHero(container) {
    if (container.querySelector('.fs-hero')) return;
    var hero = el('div', 'fs-hero');
    hero.innerHTML =
      '<span class="fs-hero__badge">無料サンプル</span>' +
      '<p class="fs-hero__title">気になるグッズの<em>実物</em>を、<em>無料</em>でお送りします。</p>' +
      '<p class="fs-hero__lead">カタログや画面では分からない、素材の厚み・手ざわり・印刷の仕上がりを、お手元でご確認いただけます。</p>' +
      '<ul class="fs-hero__points">' +
      '<li>商品代金は無料（各アイテム1点ずつ）</li>' +
      '<li>ネコポスでお届け（送料は当店負担）</li>' +
      '<li>写真を選んで、お届け先を書くだけ</li>' +
      '</ul>' +
      '<p class="fs-hero__note">※ 厚みのある商品や複数点のご請求は、宅急便（着払い）でのお届けになる場合があります。詳しくは下の「配送について」をご覧ください。</p>';
    var app = container.querySelector('.globo-form-app');
    if (app && app.parentNode) app.parentNode.insertBefore(hero, app);
  }

  function moveShippingNotice(root) {
    var header = root.querySelector('form.g-container > .header[data-path="header"]');
    var footer = root.querySelector('.gfb__footer, .globo-form-app .footer');
    if (!header || !footer || header.closest('.fs-ship')) return;
    var det = el('details', 'fs-ship');
    var sum = el('summary');
    sum.textContent = '配送について（ネコポス／宅急便の扱い）';
    det.appendChild(sum);
    header.parentNode.removeChild(header);
    det.appendChild(header);
    footer.parentNode.insertBefore(det, footer);
  }

  function addSectionHead(root) {
    if (root.querySelector('.fs-section-head')) return;
    var anchor = root.querySelector('[data-element-id="text"]');
    if (!anchor) return;
    var box = el('div', 'fs-section-head');
    box.innerHTML =
      '<p class="fs-section-head__title">お届け先を教えてください</p>' +
      '<p class="fs-section-head__sub">サンプルは実物をお送りします。ご住所は番地・建物名までご記入ください。</p>';
    anchor.parentNode.insertBefore(box, anchor);
  }

  function addSubmitNote(root) {
    var footer = root.querySelector('.gfb__footer, .globo-form-app .footer');
    if (!footer || footer.querySelector('.fs-submit-note:not(.fs-agree-text)')) return;
    var p = el('p', 'fs-submit-note');
    p.innerHTML = '<span class="fs-submit-count">サンプルが選ばれていません</span>';
    // ★ 送信ボタンの「上」に置く。下に置くとフッターに埋もれて見えない
    var btn = footer.querySelector('button.action');
    if (btn) footer.insertBefore(p, btn);
    else footer.appendChild(p);
  }

  /* ---------- 5) 必須を7つ→5つに ----------
     残す必須: お名前 / 郵便番号 / ご住所 / 電話番号 / メール （5つ）
     やめる  : 「宅急便での発送について 同意します」
               「内容確認後、チェックをつけて送信してください」
     ※ 宅急便の同意は、送信ボタンの直前に文章で明示する（送信をもって同意）。
        送信記録にも残るよう値は付けたまま送る。 */
  function applyRequired5(root) {
    if (!REQUIRED_5) return;

    // 「内容確認後…」= 中身のない二重確認。廃止
    var confirmBox = root.querySelector('[data-element-id="checkbox-1"]');
    if (confirmBox && !confirmBox.classList.contains('fs-hidden')) {
      var ci = confirmBox.querySelector('input.checkbox-input');
      if (ci) { ci.removeAttribute('presence'); ci.checked = true; }
      confirmBox.classList.add('fs-hidden');
    }
    // 宅急便の同意 → チェック欄をやめ、文章で明示する
    var agree = root.querySelector('[data-element-id="checkbox-10"]');
    if (agree && !agree.classList.contains('fs-hidden')) {
      var ai = agree.querySelector('input.checkbox-input');
      if (ai) { ai.removeAttribute('presence'); ai.checked = true; }
      agree.classList.add('fs-hidden');
    }
    var footer = root.querySelector('.gfb__footer, .globo-form-app .footer');
    if (footer && !footer.querySelector('.fs-agree-text')) {
      var p = el('p', 'fs-submit-note fs-agree-text');
      p.textContent = '「送信する」を押すと、配送条件（厚みのある商品・複数点のご請求は宅急便・着払いになる場合があります）にご同意いただいたものとします。';
      footer.insertBefore(p, footer.firstChild);
    }
    // 念のため、必須の5つに presence が付いていることを確かめる
    ['text', 'text-2', 'text-3', 'phone-1', 'email'].forEach(function (id) {
      var e = byId(id);
      if (e && !e.hasAttribute('presence')) e.setAttribute('presence', '');
    });
  }

  /* ---------- 6) エラー時に最初のエラーまでスクロール ---------- */
  function hookSubmitScroll(root) {
    var btn = root.querySelector('button.action.submit, button.action.next');
    if (!btn || btn.__fsHooked) return;
    btn.__fsHooked = true;
    btn.addEventListener('click', function () {
      setTimeout(function () {
        translateAll(root);
        var bad = root.querySelector('small.messages:not(:empty)');
        if (bad) {
          var ctl = bad.closest('.globo-form-control') || bad;
          var y = ctl.getBoundingClientRect().top + window.pageYOffset - 90;
          window.scrollTo({ top: y, behavior: 'smooth' });
        }
      }, 120);
    });
  }

  /* ---------- 7) 送信完了 → サンクスページ ---------- */
  function hookThanks(root) {
    if (!THANKS_REDIRECT || root.__fsThanks) return;
    root.__fsThanks = true;
    var done = false;
    var check = function () {
      if (done) return;
      // ★ .message.success はフォーム内と外の2か所にある。どちらが出るか分からないので
      //    全部見る。表示判定は getClientRects()（実際に描画されているか）で行う。
      var list = root.querySelectorAll('.message.success');
      for (var i = 0; i < list.length; i++) {
        if (list[i].getClientRects().length > 0) {
          done = true;
          window.location.assign(THANKS_URL);
          return;
        }
      }
    };
    new MutationObserver(check).observe(root, {
      subtree: true, childList: true, attributes: true,
      attributeFilter: ['class', 'style', 'hidden']
    });
    setInterval(check, 500);
  }

  /* ---------- 組み立て ---------- */
  function enhance() {
    var root = document.querySelector('.globo-form-id-' + FORM_ID);
    if (!root) return false;
    if (!root.querySelector('form.g-container')) return false;
    buildHero(root);
    moveShippingNotice(root);
    buildPicker(root);
    addSectionHead(root);
    fixInputs(root);
    applyRequired5(root);
    addSubmitNote(root);
    hookSubmitScroll(root);
    hookThanks(root);
    translateAll(root);
    var picker = root.querySelector('.fs-picker');
    if (picker && picker.__fsSync) picker.__fsSync();
    return true;
  }

  // ★ enhance() 自身がDOMを書き換えるので、素直に observe すると自分の変更で
  //    再び自分が呼ばれて止まらなくなる。busyフラグ + rAF で1フレーム1回に抑える。
  var pending = false, busy = false;
  function enhanceSafe() {
    if (busy || pending) return;
    pending = true;
    requestAnimationFrame(function () {
      pending = false;
      busy = true;
      try { enhance(); } catch (e) { log('enhance失敗: ' + e); }
      busy = false;
    });
  }

  function watch() {
    var host = document.querySelector('.globo-form-id-' + FORM_ID);
    var target = (host && host.parentNode) || document.body;
    new MutationObserver(enhanceSafe).observe(target, { childList: true, subtree: true });
  }

  function start() {
    if (enhance()) { watch(); return; }
    var tries = 0;
    var t = setInterval(function () {
      tries++;
      if (enhance()) { clearInterval(t); watch(); return; }
      if (tries > 300) {                // 最大30秒待つ
        clearInterval(t);
        log('フォームが見つかりませんでした（Globoが描画していない）');
      }
    }, 100);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
